import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import type { Template } from "./types";

interface TemplatePreviewDialogProps {
  template: Template | null;
  onClose: () => void;
}

const TemplatePreviewDialog: React.FC<TemplatePreviewDialogProps> = ({
  template,
  onClose,
}) => {
  return (
    <Dialog
      open={!!template}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      slotProps={{
        paper: {
          sx: { borderRadius: 3, height: "70vh" },
          elevation: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {template?.name ?? "Template Preview"}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          aria-label={`Close preview: ${template?.name ?? "template"}`}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box
          sx={{
            p: 3,
            fontFamily: "monospace",
            fontSize: "0.85rem",
            whiteSpace: "pre-wrap",
            color: "text.primary",
            overflowY: "auto",
            height: "100%",
          }}
        >
          {template?.content ?? "No content available."}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TemplatePreviewDialog;
